// by lxm
import http from './http.js';

/**
 * 这里统一处理项目中所有的 api 接口
 */
// const baseUrl = '/common';
// 登录
export const login = params => http.post(`/api/Login/Login`,params);
// 获取手机验证码
export const sendSms = params => http.post(`/api/Login/SendSms`,params);
// 手机号注册
export const register = params => http.post(`/api/Login/Register`,params);
// 登出
export const logOut = params => http.post(`/api/Login/LogOut`,params);
// 获取验证码
export const getValidateImg = params => http.get(`/api/Login/GetValidateImg`,params);
